import axios from 'axios';
import { BASE_URL } from '../components/Constant';

const authHeaders = () => ({
  // eslint-disable-next-line no-undef
  authorization: `${localStorage.getItem('token')}`
});

function getInvoices(params = {}) {
  return axios.get(BASE_URL + 'invoices', {
    headers: authHeaders(),
    params
  });
}

function getInvoiceEmails(params = {}) {
  return axios.get(BASE_URL + 'invoices/emails', {
    headers: authHeaders(),
    params
  });
}

function getBoxshallProducts(params = {}) {
  return axios.get(BASE_URL + 'invoices/boxshall-products', {
    headers: authHeaders(),
    params
  });
}

function previewBoxshallProduct(product) {
  return axios.post(BASE_URL + 'invoices/boxshall-products/preview', product, {
    headers: authHeaders()
  });
}

function downloadInvoicePdf(invoiceId) {
  return axios.get(BASE_URL + `invoices/${invoiceId}/pdf`, {
    headers: authHeaders(),
    responseType: 'blob'
  });
}

function reprocessInvoice(invoiceId) {
  return axios.post(BASE_URL + `invoices/${invoiceId}/reprocess`, {}, { headers: authHeaders() });
}

function approveInvoice(invoiceId) {
  return axios.post(BASE_URL + `invoices/${invoiceId}/approve`, {}, { headers: authHeaders() });
}

function deleteInvoice(invoiceId) {
  return axios.delete(BASE_URL + `invoices/${invoiceId}`, { headers: authHeaders() });
}

function submitInvoices(invoices, selectionMode = 'selected') {
  return axios.post(BASE_URL + 'invoices/submit', { invoices, selectionMode }, { headers: authHeaders() });
}

function checkDocNumbers(invoices) {
  return axios.post(BASE_URL + 'invoices/check-doc-numbers', { invoices }, { headers: authHeaders() });
}

function updateInvoice(invoiceId, changes) {
  return axios.patch(BASE_URL + `invoices/${invoiceId}`, changes, {
    headers: authHeaders()
  });
}

function createInvoice(invoice) {
  return axios.post(BASE_URL + 'invoices', invoice, {
    headers: authHeaders()
  });
}

function uploadManualInvoiceFile(invoiceId, file) {
  // eslint-disable-next-line no-undef
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(BASE_URL + `invoices/${invoiceId}/file`, formData, {
    headers: authHeaders()
  });
}

function createSupplierVendor(invoiceId, vendor) {
  return axios.post(BASE_URL + `invoices/${invoiceId}/supplier/vendor`, vendor, { headers: authHeaders() });
}

function createCustomer(invoiceId, lineIndex, customer) {
  return axios.post(BASE_URL + `invoices/${invoiceId}/line-items/${lineIndex}/customer`, customer, {
    headers: authHeaders()
  });
}

function createBoxshallProduct(invoiceId, lineIndex, product) {
  return axios.post(BASE_URL + `invoices/${invoiceId}/line-items/${lineIndex}/boxshall-product`, product, {
    headers: authHeaders()
  });
}

function extractInvoiceFile(file) {
  // eslint-disable-next-line no-undef
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(BASE_URL + 'invoices/imports', formData, {
    headers: authHeaders()
  });
}

function reprocessInvoiceImport(importId) {
  return axios.post(BASE_URL + `invoices/imports/${importId}/reprocess`, {}, { headers: authHeaders() });
}

function saveInvoiceImport(importId, invoices) {
  return axios.post(BASE_URL + `invoices/imports/${importId}/commit`, { invoices }, { headers: authHeaders() });
}

function discardInvoiceImport(importId) {
  return axios.delete(BASE_URL + `invoices/imports/${importId}`, { headers: authHeaders() });
}

function downloadInvoiceImportFile(importId) {
  return axios.get(BASE_URL + `invoices/imports/${importId}/file`, {
    headers: authHeaders(),
    responseType: 'blob'
  });
}

const invoiceService = {
  approveInvoice,
  checkDocNumbers,
  createCustomer,
  createInvoice,
  createBoxshallProduct,
  createSupplierVendor,
  deleteInvoice,
  discardInvoiceImport,
  downloadInvoicePdf,
  downloadInvoiceImportFile,
  extractInvoiceFile,
  getBoxshallProducts,
  getInvoiceEmails,
  getInvoices,
  previewBoxshallProduct,
  reprocessInvoice,
  reprocessInvoiceImport,
  saveInvoiceImport,
  submitInvoices,
  updateInvoice,
  uploadManualInvoiceFile
};

export default invoiceService;
